import styled from 'styled-components'

export const Image = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 10px;
`
